import _defineProperty from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.promise.all-settled.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { setUserId, trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { IDENTIFIED_USER_SESSION_NAME, SNOWPLOW } from './constants';
import { getBrowsingApp, getCountryPlatform, getLaunchDarklyConsent, initExponea, initSnowplow, isCustomerLoggedIn, isRaisinFrontend } from './utils';
/*
 * this folder will be removed once the stand-alone library is finished
 * this is needed to create a LD user and send Snowplow events to LD
 */

import { getFeatureFlagClient, createRaisinFrontendUser } from './getFeatureFlagClient';
export var initializeTracking = function initializeTracking(locale) {
  var enableExponea = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var appId = arguments.length > 2 ? arguments[2] : undefined;
  window.sessionStorage.removeItem(IDENTIFIED_USER_SESSION_NAME);
  initSnowplow(locale, appId);

  if (enableExponea) {
    initExponea(locale);
  }
  /*
   * returns whether the user has accepted
   * or rejected the UserCentrics consent
   */


  getLaunchDarklyConsent();
};
export var isExponeaInitialized = function isExponeaInitialized() {
  var _a;

  return typeof global !== 'undefined' && !!((_a = global.window) === null || _a === void 0 ? void 0 : _a['exponea']);
};
export var trackEvent = function trackEvent(_a, trackToExponea, trackToSnowplow, targetURL, event, openInNewTab) {
  var schema = _a.schema,
      trackingProperties = __rest(_a, ["schema"]);

  if (trackToExponea === void 0) {
    trackToExponea = false;
  }

  if (trackToSnowplow === void 0) {
    trackToSnowplow = true;
  }

  if (targetURL === void 0) {
    targetURL = undefined;
  }

  if (event === void 0) {
    event = undefined;
  }

  if (openInNewTab === void 0) {
    openInNewTab = false;
  }

  var promises = [];
  var trackingData = mapTrackingData(trackingProperties);

  if (event) {
    event.preventDefault();
  }

  if (process.env.NODE_ENV === 'development') {
    console.debug('Tracking event emitted', trackingProperties);
  }

  if (trackToExponea) {
    promises.push(trackEventToExponea({
      trackingData: trackingData
    }));
  }

  if (trackToSnowplow) {
    promises.push(trackEventToSnowplow({
      schema: schema,
      trackingData: trackingData
    }));
  }
  /*
   * NOTE: This is specific for customer-portal
   * other portals such as CAP or Raisin frontend might not work
   * send Snowplow events to Launch Darkly
   * only if the user has given consent (UserCentrics)
   */
  // temporarily comment out the LD consent check


  promises.push(trackEventToLaunchDarkly({
    trackingData: trackingData
  }));
  return Promise.allSettled(promises).then(function (results) {
    var rejections = results.map(function (result) {
      return result.status === 'rejected' ? result.reason : null;
    }).filter(Boolean);

    if (targetURL) {
      if (openInNewTab) {
        window.open(targetURL, '_blank');
      } else {
        window.location.href = targetURL;
      }
    }

    if (rejections.length) {
      var _console;

      (_console = console).warn.apply(_console, ['One or more tracking events failed'].concat(_toConsumableArray(rejections)));
    }
  });
};

var mapTrackingData = function mapTrackingData(_ref) {
  var eventName = _ref.eventName,
      object = _ref.object,
      action = _ref.action,
      portal = _ref.portal,
      description = _ref.description,
      boundedContext = _ref.boundedContext,
      zone = _ref.zone,
      bipsDomain = _ref.bipsDomain,
      context = _ref.context,
      component = _ref.component,
      productId = _ref.productId,
      customerGroup = _ref.customerGroup,
      customAttribute1 = _ref.customAttribute1,
      customAttribute2 = _ref.customAttribute2,
      customAttribute3 = _ref.customAttribute3,
      customAttribute4 = _ref.customAttribute4,
      customAttribute5 = _ref.customAttribute5,
      customAttribute6 = _ref.customAttribute6,
      customAttribute7 = _ref.customAttribute7,
      customAttribute8 = _ref.customAttribute8,
      customAttribute9 = _ref.customAttribute9,
      customAttribute10 = _ref.customAttribute10,
      countryPlatform = _ref.countryPlatform;
  return {
    event_name: eventName,
    object: object,
    action: action,
    portal: portal,
    description: description,
    bounded_context: boundedContext,
    zone: zone,
    context: context,
    component: component,
    product_id: productId,
    bips_domain: bipsDomain,
    browsing_platform: getBrowsingApp(),
    country_platform: countryPlatform || getCountryPlatform(),
    customer_group: customerGroup,
    custom_attribute_1: customAttribute1,
    custom_attribute_2: customAttribute2,
    custom_attribute_3: customAttribute3,
    custom_attribute_4: customAttribute4,
    custom_attribute_5: customAttribute5,
    custom_attribute_6: customAttribute6,
    custom_attribute_7: customAttribute7,
    custom_attribute_8: customAttribute8,
    custom_attribute_9: customAttribute9,
    custom_attribute_10: customAttribute10
  };
};

var trackEventToSnowplow = function trackEventToSnowplow(_ref2) {
  var schema = _ref2.schema,
      trackingData = _ref2.trackingData;
  return new Promise(function (resolve) {
    var isLoggedIn = isCustomerLoggedIn();
    var event = {
      event: {
        schema: schema || SNOWPLOW.SCHEMA,
        data: trackingData
      }
    };

    if (isLoggedIn) {
      var counter = 0;
      var interval = setInterval(function () {
        var isUserIdentified = !!window.sessionStorage.getItem(IDENTIFIED_USER_SESSION_NAME);

        if (isUserIdentified) {
          trackSelfDescribingEvent(event);
          clearInterval(interval);
          resolve();
        }

        if (++counter > 10) {
          clearInterval(interval);
          resolve();
        }
      }, 300);
    } else {
      trackSelfDescribingEvent(event);
      resolve();
    }
  });
};

var trackEventToExponea = function trackEventToExponea(_ref3) {
  var trackingData = _ref3.trackingData;
  return new Promise(function (resolve, reject) {
    var successCallback = function successCallback() {
      resolve();
    };

    var errorCallback = function errorCallback() {
      reject('Exponea failed to fire a tracking event');
    };

    var exponeaObject = window === null || window === void 0 ? void 0 : window['exponea'];

    if (exponeaObject === null || exponeaObject === void 0 ? void 0 : exponeaObject.isInitialized) {
      exponeaObject.track(trackingData.event_name.toLowerCase(), trackingData, function () {
        return successCallback();
      }, function () {
        return errorCallback();
      });
      return;
    } else {
      reject('Exponea is not initialized');
    }
  });
};

var trackEventToLaunchDarkly = function trackEventToLaunchDarkly(_ref4) {
  var trackingData = _ref4.trackingData;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!isRaisinFrontend()) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return createRaisinFrontendUser();

          case 4:
            client = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.next = 9;
            return getFeatureFlagClient();

          case 9:
            client = _context.sent;

          case 10:
            if (client) {
              client.track(trackingData.event_name, {
                customProperty: trackingData
              });
            }

            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            console.warn('LaunchDarkly tracking failed:', _context.t0);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));
};

export var identifyUserBy = function identifyUserBy(type, value) {
  var exponeaObject = window === null || window === void 0 ? void 0 : window['exponea'];

  if (exponeaObject === null || exponeaObject === void 0 ? void 0 : exponeaObject.isInitialized) {
    exponeaObject.identify(_defineProperty({}, type, value));
  }

  setUserId === null || setUserId === void 0 ? void 0 : setUserId(value);
  window.sessionStorage.setItem(IDENTIFIED_USER_SESSION_NAME, 'true');
};